export function swipeNavigationTarget(currentIndex: number, pageCount: number, deltaX: number, viewportWidth: number): number | null {
  const threshold = Math.max(64, Math.min(140, viewportWidth * 0.18));
  if (Math.abs(deltaX) < threshold) return null;
  const targetIndex = currentIndex + (deltaX < 0 ? 1 : -1);
  return targetIndex >= 0 && targetIndex < pageCount ? targetIndex : null;
}

export function swipeDragOffset(currentIndex: number, pageCount: number, deltaX: number): number {
  const beyondFirstPage = currentIndex === 0 && deltaX > 0;
  const beyondLastPage = currentIndex === pageCount - 1 && deltaX < 0;
  return beyondFirstPage || beyondLastPage ? deltaX * 0.22 : deltaX;
}
